import { trackInitialGoogleAdsConversion } from '../../../../../services/googleAdsConversion.js';
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { useEffect, useRef, useState } from 'react';
import styles from './StripeCardForm.module.scss';
import { ContinueButton } from '../../../../../components/ContinueButton/ContinueButton';
import { Spinner } from '../../../../../components/Spinner/Spinner';
import cn from 'classnames';
import { ampPurchaseStatus } from '../../../../../utils/AmplitudeEvents';
import { fbInitiateCheckout } from '../../../../../utils/FacebookEvents';
import { getSavedUtm } from "../../../../../services/utmHelpers.js";
import { getReferpulseAttribution } from '../../../../../services/referpulseAttribution.js';
import { trackGoogleAdsCheckoutStart } from '../../../../../utils/GoogleAdsFunnelEvents';
export function StripeCardForm({ email, data:priceInfo, currency,onSuccess,setMessage }) {
  // const [cardholderName, setCardholderName] = useState('');
  const [onChange, setOnChange] = useState(false);
  const [cardNumberError, setCardNumberError] = useState(null);
  const [cardDateError, setCardDateError] = useState(null);
  const [cardCvcError, setCardCvcError] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cardholderName, setCardholderName] = useState('');
  const [inputFocused, setInputFocused] = useState(false);
  const nameMessage = 'Only A–Z, spaces, and dashes allowed';
  const submitting = useRef(false);
  const stripe = useStripe();
  const elements = useElements();
  useEffect(() => {
    if (onChange) {
      fbInitiateCheckout();
    }
  }, [onChange]);

  // console.log(priceInfo)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements || submitting.current) return;
    trackGoogleAdsCheckoutStart();
    submitting.current = true;
    try {
      ampPurchaseStatus('started');
      setLoading(true);
      const card = elements.getElement(CardNumberElement);
      if (!card) {
        console.error("Card element is not mounted!");
        return;
      }
      const { error: pmError, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card,
        billing_details: {
          name: cardholderName || '',
          email: email || '',
        },
      });
      if (pmError) {
        ampPurchaseStatus('decline',pmError.message);
        setMessage(pmError.message);
        return;
      }
      // 2. Отправляем paymentMethod.id, email, priceId на сервер
      const utm = getSavedUtm();
      const referpulse = getReferpulseAttribution();
      const {priceID,periodDays,oneTimePriceID} = priceInfo;
      const response = await fetch('/api/create-subscription.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          paymentMethodId: paymentMethod.id,
          email,
          priceID,
          oneTimePriceID,
          periodDays,
          currency,
          utm,
          referpulse,
          plan: priceInfo.title || ''
        }),
      });

      const data = await response.json();
      if (data.error) {
        setMessage(data.error)
        ampPurchaseStatus('decline',data.error);
        return;
      }
      let paymentStatus = data.paymentIntentStatus;
      if (data.clientSecret && data.paymentIntentStatus !== 'succeeded') {

        const confirmResult = await stripe.confirmCardPayment(data.clientSecret, {
          payment_method: paymentMethod.id
        });

        paymentStatus = confirmResult.paymentIntent?.status;
        if (confirmResult.error) {
          setMessage(confirmResult.error.message);
          ampPurchaseStatus('decline',confirmResult.error.message);
          return;
        }
      }
      if (paymentStatus !== 'succeeded') {
        setMessage('Payment is not confirmed yet. Please contact support before retrying.');
        return;
      }
      const setPaymentData  = await fetch('/api/attach-card-subscription.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          payment_intent_id: data.paymentIntentId,
          customerID: data.customerID,
          priceID,
          periodDays,
          currency,
          utm,
          referpulse,
          plan: priceInfo.title || ''
        }),
      });
      const paymentData = await setPaymentData.json();
      if (paymentData.success !== true) {
        setMessage(paymentData.error || 'Payment could not be verified. Please contact support.');
        return;
      }
      trackInitialGoogleAdsConversion(paymentData);
      onSuccess && onSuccess(paymentData);
    } catch (error) {
      setMessage(error.message || 'Payment could not be completed. Please contact support.');
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };
  const stripeElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        color: '#ffffff',
        '::placeholder': { color: '#B39DDB' },
        fontFamily: 'system-ui',
        iconColor: '#B39DDB',
        borderColor: '#473C7E',
      },
      invalid: {
        color: '#f44336',
      },
      complete: {
        color: '#ffffff',
        borderColor: '#ffffff' ,
        iconColor: '#ffffff',
      },
    },
    hidePostalCode: false,
    showIcon:true,
    iconStyle: 'default',
  };

  return (
    <div className={styles.stripeForm} aria-busy={loading}>
      {loading && <Spinner/>}
      <div className={styles.label}>
        <CardNumberElement className={styles.stripeCardElement}
        onFocus={trackGoogleAdsCheckoutStart}
        onChange={function (event){
          setOnChange(true);
          const message = event.error ? event.error.message : null;
          setCardNumberError(message)
        }}
        // onFocus={setCardNumberError(null)}
        options={stripeElementOptions} />
        {cardNumberError && <div className={styles.messageError}>{cardNumberError}</div>}
      </div>

      <div className={styles.stripeRow}>
        <div className={styles.label}>
          <CardExpiryElement className={styles.stripeCardElement}
          onChange={function (event){
            setOnChange(true);
            const message = event.error ? event.error.message : null;
            setCardDateError(message)
          }}
          options={stripeElementOptions} />
          {cardDateError && <div className={styles.messageError}>{cardDateError}</div>}
        </div>
        <div className={styles.label}>
          <CardCvcElement className={styles.stripeCardElement}
              onChange={function (event){
                setOnChange(true);
                const message = event.error ? event.error.message : null;
              setCardCvcError(message)
            }}

          options={stripeElementOptions} />
          {cardCvcError && <div className={styles.messageError}>{cardCvcError}</div>}
        </div>
      </div>
      <div className={styles.label}>
        <input
        className={cn(
          styles.stripeCardElement,
          styles.stripeCardHolder,
          ((inputFocused || cardholderName) && cardholderName.length>2) && styles.focused
        )}
        name="cardholderName"
        placeholder="Cardholder Name"
        value={cardholderName}
        onChange={(e) => {
          const value = e.target.value;
          setOnChange(true);
          // Регулярка: латиница + пробел + дефис (до 50 символов)
          const valid = /^[A-Za-z\s-]*$/.test(value);

          if (valid && value.length <= 50) {
            setCardholderName(value);
            setNameError(null);
          } else {
            setNameError(nameMessage);
          }
        }}
        onFocus={() => setInputFocused(true)}
        onBlur={() => setInputFocused(false)}
        />
        {nameError && <div className={styles.messageError}>{nameError}</div>}
      </div>

      <ContinueButton onClick={handleSubmit} aria-disabled={loading} className={styles.stripeButton}><span>🔒</span> Continue</ContinueButton>
    </div>
  );
}
